<template>
    <div :id="`content-media-${data.id}`" class="content-media">
        <div class="page-media">
            <UiImage :src="data?.media[0].webp" />
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
});
</script>
